import { render, staticRenderFns } from "./TransportPage.vue?vue&type=template&id=095f3c73&scoped=true"
import script from "./TransportPage.vue?vue&type=script&lang=js"
export * from "./TransportPage.vue?vue&type=script&lang=js"
import style0 from "./TransportPage.vue?vue&type=style&index=0&id=095f3c73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f3c73",
  null
  
)

export default component.exports